import { useQuery } from '@tanstack/react-query';
import { createStripeSubscriptionManagementUrl } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

const STRIPE_MANAGEMENT_URL_TTL_MS = 5 * 60 * 1000;
export const queryKey = 'stripe-management-url';

export const useStripeSubscriptionManagementUrlQuery = (
  stripeCustomerId: ID | undefined,
) =>
  useQuery<string>({
    queryKey: [queryKey, stripeCustomerId],
    queryFn: () => {
      if (!stripeCustomerId) {
        throw new Error('stripeCustomerId is required to fetch management url');
      }
      return createStripeSubscriptionManagementUrl(stripeCustomerId);
    },
    enabled: false,
    staleTime: STRIPE_MANAGEMENT_URL_TTL_MS,
    gcTime: STRIPE_MANAGEMENT_URL_TTL_MS,
  });
